import { appHttpClient } from "../../installations/http/axiosInterfaces";
import { dedupeRequest } from "../../installations/http/inFlight";

// All calls go through appHttpClient, so the M1 Bearer interceptor authenticates them.

const getAllAgents = () => {
  // 0016: dedupe StrictMode double-invoke (the useAgentListQuery queryFn) into one network request.
  return dedupeRequest("agents", () => appHttpClient.get("/Agent/List"));
};

const getAgentAssignments = (id) => {
  // 0016: dedupe StrictMode double-invoke; key on the agent id so different agents fetch independently.
  return dedupeRequest(`agentAssignments:${id}`, () =>
    appHttpClient.get(`/Agent/${id}/Assignments`)
  );
};

const setAgentAssignments = (id, customerIds) => {
  return appHttpClient.post(`/Agent/${id}/Assignments`, { customerIds });
};

const setAgentPermissions = (id, canAddCustomers) => {
  return appHttpClient.put(`/Agent/${id}/Permissions`, { canAddCustomers });
};

const setAgentActive = (id, isActive) => {
  return appHttpClient.put(`/Agent/${id}/Active`, { isActive });
};

const deleteAgent = (id) => {
  return appHttpClient.delete(`/Agent/${id}`);
};

const registerAgent = (data) => {
  return appHttpClient.post("/Account/Register/Agent", data);
};

// 0006: edit an agent's identity fields (first/last/phone, email).
const updateAgent = (id, data) => {
  return appHttpClient.put(`/Agent/${id}`, data);
};

// 0006: admin-initiated password reset for a specific agent (temp password emailed).
const resetAgentPassword = (id) => {
  return appHttpClient.post(`/Agent/${id}/ResetPassword`);
};

const agentService = {
  getAllAgents,
  getAgentAssignments,
  setAgentAssignments,
  setAgentPermissions,
  setAgentActive,
  deleteAgent,
  registerAgent,
  updateAgent,
  resetAgentPassword,
};

export default agentService;
